{"theme":"trial","routeImagesSupported":false,"defaultLocale":"en","companyForm":true,"privatePersonForm":false,"hasHomepage":false}